import { render, staticRenderFns } from "./ContestNotification.vue?vue&type=template&id=aba20b1e&scoped=true"
import script from "./ContestNotification.vue?vue&type=script&lang=ts"
export * from "./ContestNotification.vue?vue&type=script&lang=ts"
import style0 from "./ContestNotification.vue?vue&type=style&index=0&id=aba20b1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba20b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aba20b1e')) {
      api.createRecord('aba20b1e', component.options)
    } else {
      api.reload('aba20b1e', component.options)
    }
    module.hot.accept("./ContestNotification.vue?vue&type=template&id=aba20b1e&scoped=true", function () {
      api.rerender('aba20b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ContestNotification.vue"
export default component.exports